'use strict';
import angular from 'angular';
import AkrisOrderSummaryListController from './akris-order-summary-list.controller';
export default angular.module('directives.orderList')
    .controller('AkrisOrderSummaryListController', AkrisOrderSummaryListController)
    .component('akrisOrderSummaryList', {
    template: require('../order-summary-list.html'),
    bindings: {
        loadingBar: '<',
        cart: '<',
    },
    controller: AkrisOrderSummaryListController
})
    .name;
//# sourceMappingURL=index.js.map